import { Button, Input, Modal, Select, Spin, Typography } from "antd";
import Title from "antd/es/typography/Title";
import React, { useState } from "react";
import { ADD_USER_INITIAL_OBJECT } from "../../screens/admin/userManagement/UserManagementUtils";
import { UserManagementAPI } from "../../API/admin/UserManagementAPI";
const { Text } = Typography;

function AddEmployees({
  open,
  setOpen,
  messageToast,
  setTempModal,
  setTempData,
  loadConfigData,
}) {
  const validEmailRgex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const [inputElements, setInputElements] = useState(ADD_USER_INITIAL_OBJECT);
  const [loadSpin, setLoadSpin] = useState(false);

  function backFun() {
    setInputElements(ADD_USER_INITIAL_OBJECT);
    setOpen(false);
  }

  function handleChange(value, name) {
    if (name === "email") {
      setInputElements((prev) => ({
        ...prev,
        [name]: value,
        errorMessage: {
          ...prev.errorMessage,
          [name]: !value.trim()
            ? "Field is required"
            : !validEmailRgex.test(value.trim())
              ? "Invalid Email"
              : "",
        },
      }));
    } else {
      let error = "";

      if (!value.trim()) {
        error = "Field is required";
      } else if (value.trim().length >= 100) {
        error = "MAX length 100!";
      }
      setInputElements((prev) => ({
        ...prev,
        [name]: value,
        errorMessage: {
          ...prev.errorMessage,
          [name]: error,
        },
      }));
    }
  }

  async function addFun() {
    if (formValidation()) {
      setLoadSpin(true);
      const bodyData = {
        email: inputElements.email,
        first_name: inputElements.firstName,
        last_name: inputElements.lastName,
        is_admin: inputElements.user === "admin" ? true : false,
      };
      await UserManagementAPI.creatUserPost(bodyData)
        .then((res) => {
          if (res.data.status === true) {
            setOpen(false);
            setLoadSpin(false);
            setInputElements(ADD_USER_INITIAL_OBJECT);
            messageToast("success", "New user added successfully");
            loadConfigData();
            setTempModal(true);
            setTempData({
              firstName: res?.data?.first_name,
              lastName: res?.data?.last_name,
              pass: res?.data?.temp_pass,
            });
          } else {
            messageToast("error", res?.data?.message);
            setLoadSpin(false);
          }
        })
        .catch(() => {
          messageToast("error", "Internal Server Error");
          setLoadSpin(false);
        });
    }
  }

  function formValidation() {
    let isValid = false;
    let obj = { ...inputElements };

    obj.errorMessage = {
      ...inputElements.errorMessage,
      firstName: !inputElements.firstName
        ? "Field is required"
        : inputElements.firstName.trim().length >= 100
          ? "MAX length 100!"
          : "",
      lastName: !inputElements.lastName
        ? "Field is required"
        : inputElements.lastName.trim().length >= 100
          ? "MAX length 100!"
          : "",
      email: !inputElements.email
        ? "Field is required"
        : !validEmailRgex.test(inputElements.email.trim())
          ? "Invalid Email"
          : "",
      user: !inputElements.user ? "Field is required" : "",
    };

    setInputElements(obj);

    if (
      obj.firstName &&
      !obj.errorMessage.firstName &&
      obj.lastName &&
      !obj.errorMessage.lastName &&
      obj.email &&
      !obj.errorMessage.email &&
      obj.user &&
      !obj.errorMessage.user
    ) {
      isValid = true;
    }

    return isValid;
  }

  return (
    <Modal
      open={open}
      okText="Apply"
      cancelText="Clear All"
      onCancel={() => backFun()}
      footer={[
        <Button key="back" type="text" onClick={backFun}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={addFun}>
          Add
        </Button>,
      ]}
    >
      <Spin spinning={loadSpin}>
        <div style={{ padding: "10px" }}>
          <div
            style={{
              marginBottom: "20px",
              borderBottom: "solid 1px #80808047",
            }}
          >
            <Title level={5}>Add New User</Title>
          </div>

          <div style={{ gap: 10 }}>
            <div style={{ marginBottom: "15px" }}>
              <label>First Name</label>
              <Input
                status={
                  inputElements.errorMessage.firstName === "" ? "" : "error"
                }
                value={inputElements.firstName}
                onChange={(e) =>
                  handleChange(e.target.value.trimStart(), "firstName")
                }
              />
              <Text type="danger" italic>
                {inputElements.errorMessage.firstName}
              </Text>
            </div>
            <div style={{ marginBottom: "15px" }}>
              <label>Last Name</label>
              <Input
                status={
                  inputElements.errorMessage.lastName === "" ? "" : "error"
                }
                value={inputElements.lastName}
                onChange={(e) =>
                  handleChange(e.target.value.trimStart(), "lastName")
                }
              />
              <Text type="danger" italic>
                {inputElements.errorMessage.lastName}
              </Text>
            </div>
          </div>
          <div style={{ gap: 10 }}>
            <div style={{ marginBottom: "15px" }}>
              <label>Email ID</label>
              <Input
                status={inputElements.errorMessage.email === "" ? "" : "error"}
                value={inputElements.email}
                onChange={(e) =>
                  handleChange(e.target.value.trimStart(), "email")
                }
              />
              <Text type="danger" italic>
                {inputElements.errorMessage.email}
              </Text>
            </div>
          </div>
          <div style={{ marginBottom: "15px" }}>
            <label>User Group</label>
            <Select
              allowClear
              status={inputElements.errorMessage.user === "" ? "" : "error"}
              style={{
                background: "#EBEEF8",
                fontSize: "13px",
                display: "block",
              }}
              value={inputElements.user}
              onChange={(e) => {
                const value = e;
                setInputElements((prev) => ({
                  ...prev,
                  user: value,
                  errorMessage: {
                    ...prev.errorMessage,
                    user: !value ? "Field is required" : "",
                  },
                }));
              }}
              options={[
                { value: "user", label: "User" },
                { value: "admin", label: "Admin" },
              ]}
            />
            <Text type="danger" italic>
              {inputElements.errorMessage.user}
            </Text>
          </div>
        </div>
      </Spin>
    </Modal>
  );
}

export default AddEmployees;
